module.exports = __webpack_public_path__ + "static/media/icon-download.ce2002cf.svg";